import { addMessages } from '@hana/i18n';

// Khoá chuỗi chrome; dữ liệu, mã nghiệp vụ không dịch.
addMessages('vi', {
 'cd.1': 'tỷ lệ mở',
 'cd.2': '% mở',
 'cd.3': '% bấm',
 'cd.4': 'Phân khúc',
 'cd.5': 'Khách theo Sale',
 'cd.6': 'Khách',
 'cd.7': 'Địa chỉ',
 'cd.8': 'Trạng thái',
 'cd.9': 'Mở',
 'cd.10': 'Bấm',
 'cd.11': 'Mở đầu',
 'cd.12': 'Thao tác',
 'cd.13': 'Thắng',
 'cd.14': 'Xem đầy đủ',
 'cd.15': 'Việc cần làm',
 'cd.16': 'Không còn việc nào cho hồ sơ này.',
 'cd.17': 'Phản hồi',
 'cd.18': 'Tạo cơ hội',
 'cd.19': 'Đã có cơ hội ›',
 'cd.20': 'Khách nóng',
 'cd.21': 'Đã trả lời',
 'cd.22': 'Thông tin chính',
 'cd.23': 'Người phụ trách',
 'cd.24': 'Liên kết',
 'cd.25': 'Cơ hội từ chiến dịch',
 'cd.26': 'Danh bạ khách',
 'cd.27': 'Mẫu email',
 'cd.28': 'Thử lại',
 'cd.29': 'Về danh sách',
});
addMessages('en', {
 'cd.1': 'open rate',
 'cd.2': '% opened',
 'cd.3': '% clicked',
 'cd.4': 'Segment',
 'cd.5': 'Customers by Sale',
 'cd.6': 'Customer',
 'cd.7': 'Addresses',
 'cd.8': 'Status',
 'cd.9': 'Opened',
 'cd.10': 'Clicked',
 'cd.11': 'First open',
 'cd.12': 'Actions',
 'cd.13': 'Won',
 'cd.14': 'View all',
 'cd.15': 'To do',
 'cd.16': 'No tasks left for this record.',
 'cd.17': 'Replies',
 'cd.18': 'Create opportunity',
 'cd.19': 'Opportunity exists ›',
 'cd.20': 'Hot customers',
 'cd.21': 'Replied',
 'cd.22': 'Key info',
 'cd.23': 'Owner',
 'cd.24': 'Links',
 'cd.25': 'Opportunities from campaign',
 'cd.26': 'Customer directory',
 'cd.27': 'Email template',
 'cd.28': 'Retry',
 'cd.29': 'Back to list',
});
addMessages('vi', {
 'cd.t1': 'Kết quả',
 'cd.t1tip': '% tính trên số địa chỉ đã gửi · mở theo pixel, bấm theo link gắn mã · thành cơ hội = cơ hội tạo từ chiến dịch',
 'cd.t2': 'Mở / bấm sau khi gửi',
 'cd.t2tip': 'Mở / bấm tích luỹ theo giờ kể từ lúc gửi · minh hoạ.',
 'cd.t2aria': 'Mở và bấm theo giờ sau khi gửi',
 'cd.t3': 'Giờ mở trong ngày',
 'cd.t3tip': 'Mở nhiều nhất 8h–10h',
 'cd.t5': 'Người nhận',
 'cd.t4': 'Nội dung',
 'cd.t4tip': 'Nội dung đã khoá lúc gửi lần đầu · muốn sửa thì Nhân bản',
 'cd.t8': 'Lịch sử',
 'cd.t8tip': 'Nhật ký chiến dịch: tạo, gửi, quét thư dội, trả lời, cơ hội.',
});
addMessages('en', {
 'cd.t1': 'Results',
 'cd.t1tip': '% of addresses sent · opens tracked by pixel, clicks by coded link · converted = opportunities created from the campaign',
 'cd.t2': 'Opens / clicks after sending',
 'cd.t2tip': 'Cumulative opens / clicks by hour since sending · illustrative.',
 'cd.t2aria': 'Opens and clicks by hour after sending',
 'cd.t3': 'Open time of day',
 'cd.t3tip': 'Most opens 8–10 am',
 'cd.t5': 'Recipients',
 'cd.t4': 'Content',
 'cd.t4tip': 'Content locked at first send · duplicate to edit',
 'cd.t8': 'History',
 'cd.t8tip': 'Campaign log: created, sent, bounce scans, replies, opportunities.',
});
